module.exports = __webpack_public_path__ + "static/scale-model-of-tom's-farms-in-corona-california-2d017b1a773409fb244eb5f367fe8e20.png";